/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';

const triggerQuantityChange = () => {
	$('.quantity').each(function () {
		const qtyInputWrapper = $(this),
			addCartButton = qtyInputWrapper.next('.add_to_cart_button'),
			input = qtyInputWrapper.find('input[type="number"]'),
			btnUp = qtyInputWrapper.find('[rel="qty-increase"]'),
			btnDown = qtyInputWrapper.find('[rel="qty-decrease"]');

		input.on('change', function () {
			const min = input.attr('min') || 1,
				max = input.attr('max') || 999,
				oldValue = parseFloat(input.val()),
				newVal =
					// eslint-disable-next-line no-nested-ternary
					oldValue < min
						? min
						: oldValue > parseFloat(max)
						  ? max
						  : oldValue;

			$(this).val(newVal);
			addCartButton.attr('data-quantity', newVal);
		});

		btnUp.click(function () {
			const max = input.attr('max') || 999,
				oldValue = parseFloat(input.val());
			let newVal =
				oldValue >= max
					? oldValue
					: oldValue + parseFloat(input.attr('step'));
			if (!max) {
				newVal = oldValue + parseFloat(input.attr('step'));
			}
			qtyInputWrapper.find('input').val(newVal);
			qtyInputWrapper.find('input').trigger('change');
		});

		btnDown.click(function () {
			const min = input.attr('min') || 1,
				oldValue = parseFloat(input.val()),
				newVal =
					oldValue <= min
						? oldValue
						: oldValue - parseFloat(input.attr('step'));

			qtyInputWrapper.find('input').val(newVal);
			qtyInputWrapper.find('input').trigger('change');
		});
	});
};

export default triggerQuantityChange;
